exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._2UKg3m0suKLw05grWJBfHi{margin:10px 18px 15px 18px}._2UKg3m0suKLw05grWJBfHi:hover .B9KV9Xlodq6ywzaXBH7F1{color:\"[theme:themePrimary, default:#0078D4]\"}", ""]);
// Exports
exports.locals = {
	"markAsCompleted": "_2UKg3m0suKLw05grWJBfHi",
	"checkboxText": "B9KV9Xlodq6ywzaXBH7F1"
};